import { DashboardCardHeader } from './DashboardCardHeader';

export default DashboardCardHeader;
